// src/classes/UpdateProfileRequest.js

export class UpdateProfileRequest {
  constructor(formData, profileId) {
    this.profileId = profileId || "";
    this.reservationId = formData.reservationId || "";
    this.givenName = formData.nameFirst || "";
    this.surname = formData.nameSur || "";
    this.rut = formData.rut || "";
    this.identificationType = formData.identificationType || "3";
    this.email = formData.email || "";
    this.sexo = formData.sexo || "";
    this.idPaisISO = formData.countryCode || "CL";
    this.fechaNacimiento = formData.fechaNacimiento || "";
    this.direccion = formData.address1 || "";
    this.address2 = formData.address2 || "";
    this.ciudad = formData.city || "";
    this.region = "";
    this.codigoPostal = formData.codigoPostal || "";
    this.telefono = formData.phoneNumber || "";
    this.taxType = formData.taxType || "";
    this.NoPost = formData.postingRestriction || false;
    this.currencyCode = formData.currencyCode || "CLP";
    this.language = formData.Language || "ES";
  }
}